import angular from 'angular';
import 'angular-bootstrap';
import 'leaflet';
import 'leaflet-draw';
import '../../locale';
import './chatsServices';
import 'Leaflet.Snap';
import '../../../scripts/leaflet-label-shim';

'use strict';

const chatsControllers = angular.module('applicationModule.chatsControllers', ['applicationModule.chatsServices', 'ui.bootstrap']);

// Chats List Controller
chatsControllers.controller('ChatsListController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'Chat', 'growl', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, NgTableParams, Chat, growl, AppsoupAPI, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('chats');
    $scope.app_id = $stateParams.application_id;
    $scope.search = {
        public: true
    };
    $scope.isFind = false;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getPublicTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Chat.getList($scope.app_id, params._params)
                .then(function (response) {
                    if (response && response.chats && typeof response.chats === 'object' && response.chats.total !== undefined) {
                        params.total(response.chats.total);
                        params.count(response.chats.per_page);
                        params.page(response.chats.current_page);
                        return response.chats.data;
                    } else if (response && response.data && response.data.chats && response.data.chats.total !== undefined) {
                        // Handle case when response has a nested data structure
                        params.total(response.data.chats.total);
                        params.count(response.data.chats.per_page);
                        params.page(response.data.chats.current_page);
                        return response.data.chats.data;
                    } else if (response && response.total !== undefined) {
                        // Handle case when response has total property directly
                        params.total(response.total);
                        params.count(response.per_page || 10);
                        params.page(response.current_page || 1);
                        return response.data || [];
                    } else if (response) {
                        // Handle case when response is returned but doesn't have expected structure
                        params.total(0);
                        params.count(10);
                        params.page(1);
                        return response.data || [];
                    } else {
                        // Handle case when response is undefined
                        params.total(0);
                        return [];
                    }
                }).finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeChat = function (id, index) {
        Chat.remove(id).then(function (response) {
            const data = response.data;
            if (data.success) {
                growl.success('MODULES.APPLICATIONS.MODULES.CHATS.SUCCESS.DELETE');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.APPLICATIONS.MODULES.CHATS.ERROR.DELETE');
            }
        });
    };

    $scope.searchChats = function (search) {
        $scope.isFind = true;
        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.public)) {
            $scope.tableParams._params.public = undefined;
        }
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);

}]);

// Chat Page Controller
chatsControllers.controller('ChatPageController', ['$scope', '$rootScope', '$stateParams', '$state', 'Chat', 'growl', 'Permissions', function ($scope, $rootScope, $stateParams, $state, Chat, growl, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('chats');

    var appId = $stateParams.application_id;
    var chatId = $stateParams.chatId;

    $scope.editMode = false;
    $scope.chat = {
        app_id: appId,
        public: true
    };

    if (angular.isDefined(chatId)) {
        $scope.editMode = true;
        $scope.isLoading = true;

        Chat.get(chatId, appId).then(function (response) {
            const data = response.data;
            if (data.success) {
                $scope.chat = data.chat;
            } else {
                growl.error('MODULES.APPLICATIONS.MODULES.CHATS.' + data.error);
            }
        }, function () {
            $state.go('appsoup.application.chats', {application_id: appId});
            growl.error('ERROR.EMPTY_DATA');
        }).finally(function () {
            $rootScope.doingResolve = false;
            $scope.isLoading = false;
        });
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');

        if ($scope.chatForm.$valid) {
            $scope.isLoading = true;
            Chat.save($scope.chat, $scope.editMode).then(function (response) {
                const data = response.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.CHATS.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    $state.go('appsoup.application.chats', {application_id: appId});
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.APPLICATIONS.MODULES.CHATS.ERROR.CREATED');
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.chats', {application_id: appId});
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.APPLICATIONS.MODULES.CHATS.ERROR.REQUIRE.NAME'}]
    };

}]);

// Chat Users Controller
chatsControllers.controller('ChatUsersController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'AppsoupAPI', 'Chat', 'Permissions', function ($scope, $rootScope, $stateParams, NgTableParams, AppsoupAPI, Chat, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('chats');
    $scope.app_id = $stateParams.application_id;
    $scope.chatId = $stateParams.chatId;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Chat.getUsersList($scope.app_id, $scope.chatId, params._params)
                .then(function (response) {
                    if (response && response.users && typeof response.users === 'object' && response.users.total !== undefined) {
                        params.total(response.users.total);
                        params.count(response.users.per_page);
                        params.page(response.users.current_page);
                        if (response.chat) {
                            $scope.chat = response.chat;
                        }
                        return response.users.data;
                    } else if (response && response.data && response.data.users && response.data.users.total !== undefined) {
                        // Handle case when response has a nested data structure
                        params.total(response.data.users.total);
                        params.count(response.data.users.per_page);
                        params.page(response.data.users.current_page);
                        if (response.data.chat) {
                            $scope.chat = response.data.chat;
                        }
                        return response.data.users.data;
                    } else if (response && response.total !== undefined) {
                        // Handle case when response has total property directly
                        params.total(response.total);
                        params.count(response.per_page || 10);
                        params.page(response.current_page || 1);
                        return response.data || [];
                    } else if (response) {
                        // Handle case when response is returned but doesn't have expected structure
                        params.total(0);
                        params.count(10);
                        params.page(1);
                        return response.data || [];
                    } else {
                        // Handle case when response is undefined
                        params.total(0);
                        return [];
                    }
                }).finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

}]);

export default chatsControllers;
